var TemplateLibrarySaveTemplateView;

TemplateLibrarySaveTemplateView = Marionette.ItemView.extend( {
	id: 'kitbuilder-template-library-save-template',

	template: '#tmpl-kitbuilder-template-library-save-template',

	ui: {
		form: '#kitbuilder-template-library-save-template-form',
		submitButton: '#kitbuilder-template-library-save-template-submit'
	},

	events: {
		'submit @ui.form': 'onFormSubmit'
	},

	getSaveType: function() {
		return this.model ? this.model.get( 'elType' ) : 'page';
	},

	templateHelpers: function() {
		var saveType = this.getSaveType(),
			templateType = kitbuilder.templates.getTemplateTypes( saveType );

		return templateType.saveDialog;
	},

	onFormSubmit: function( event ) {
		event.preventDefault();

		var formData = this.ui.form.kitbuilderSerializeObject(),
			saveType = this.model ? this.model.get( 'elType' ) : 'page',
			JSONParams = { removeDefault: true };

		formData.data = this.model ? [ this.model.toJSON( JSONParams ) ] : kitbuilder.elements.toJSON( JSONParams );

		this.ui.submitButton.addClass( 'kitbuilder-button-state' );

		kitbuilder.templates.saveTemplate( saveType, formData );
	}
} );

module.exports = TemplateLibrarySaveTemplateView;
